import React from 'react'

export const Footer = () => (
  <footer className="bg-gray-300 text-center bg-black py-4 px-20">
    <div className="max-w-screen-xl m-auto">
      <p>&#169; 2020 | Wendy Owens</p>
    </div>
  </footer>
)